if (!customElements.get('petite-trace-engraving')) {
  customElements.define(
    'petite-trace-engraving',
    class PetiteTraceEngraving extends HTMLElement {
      constructor() {
        super();

        this.engName = this.querySelector('[data-pt-eng-name]');
        this.engDate = this.querySelector('[data-pt-eng-date]');
        this.nameInput = this.querySelector('[data-pt-name-input]');
        this.dateInput = this.querySelector('[data-pt-date-input]');
        this.nameCount = this.querySelector('[data-pt-name-count]');

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.defaultName = 'Simba';
        this._painted = '';

        this.nameInput.addEventListener('input', this.onNameInput.bind(this));
        this.dateInput.addEventListener('input', this.onDateInput.bind(this));

        this.render();
      }

      /* Réduit la gravure quand le prénom s'allonge, pour qu'il tienne
         dans le médaillon (la maquette ajuste la taille au conteneur). */
      scaleFor(name) {
        const n = (name || this.defaultName).length;
        return n <= 7 ? 1 : n <= 9 ? 0.82 : n <= 11 ? 0.68 : 0.56;
      }

      onNameInput() {
        this.render();
      }

      onDateInput(e) {
        const cleaned = e.target.value.replace(/[^0-9.]/g, '').slice(0, 10);
        if (cleaned !== e.target.value) e.target.value = cleaned;
        this.render();
      }

      render() {
        const raw = this.nameInput.value;
        const name = raw.trim() || this.defaultName;
        const date = this.dateInput.value.trim();

        if (name !== this._painted) {
          this._painted = name;
          this.paintName(name);
        }
        /* Multiplicateur seulement : la taille de base est en cqw dans le CSS,
           pour que la gravure suive la taille du médaillon. */
        this.engName.style.setProperty('--pt-name-scale', this.scaleFor(raw.trim()));

        this.engDate.textContent = date;
        this.nameCount.textContent = String(raw.length);
      }

      paintName(text) {
        if (this.reduceMotion) {
          this.engName.textContent = text;
          return;
        }
        this.engName.textContent = '';
        text.split('').forEach((ch, i) => {
          const span = document.createElement('span');
          span.textContent = ch;
          span.style.display = 'inline-block';
          span.style.whiteSpace = 'pre';
          span.style.opacity = '0';
          span.style.animation = 'ptEngrave 450ms cubic-bezier(.2,.7,.3,1) forwards';
          span.style.animationDelay = i * 55 + 'ms';
          this.engName.appendChild(span);
        });
      }
    }
  );
}
